module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-2_4460b6ae95ced6ae0f208155753e9a93.png";